import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { FormatCo2eService } from 'src/app/shared/services/format-co2e.service';

@Component({
  selector: 'app-carbon-intensity',
  templateUrl: './carbon-intensity.component.html',
  styleUrl: './carbon-intensity.component.scss',
  standalone: false,
})
export class CarbonIntensityComponent implements OnInit, OnChanges {
  @Input() carbonIntensity: number = 0;
  displayedCarbonIntensity: string = '';
  displayedUnit: string = '';

  private formatCo2e = inject(FormatCo2eService);

  convertUnit() {
    this.displayedCarbonIntensity = this.formatCo2e.formatValue(this.carbonIntensity);
    this.displayedUnit = this.formatCo2e.getUnit(this.carbonIntensity);
  }
  ngOnChanges() {
    this.convertUnit();
  }
  ngOnInit() {
    this.convertUnit();
  }
}
